import React, { Component } from "react";
import { connect } from "react-redux";
import { actionCreators } from "./store";
import { Pagination } from "antd";
import ListLoader from "../../common/listloader";
import NoList from "../../common/nolist";
import abbr from "../../config/abbr";
import imgListBanner1 from "../../assets/images/listbanner1.png";
import imgDefault from "../../assets/images/default.png";
import Header from "../../common/header";
import Footer from "../../common/footer";
import "./style.css";
// import { curry } from "lodash";

class List extends Component {
  componentDidMount() {
    this.props.handleTab1Click(1011, null, 1);
  }

  render() {
    const {
      history,
      curTab1Id,
      curTab2Id,
      curTab3Id,
      curTab4Id,
      isLoader,
      page,
      total,
      handleTab1Click,
      handleTab2Click,
      handleTab3Click,
      handleTab4Click,
      onPageSizeChange,
      goVideo,
    } = this.props;
    const tab1Arr = this.props.tab1Arr.toJS();
    const tab2Arr = this.props.tab2Arr.toJS();
    const tab3Arr = this.props.tab3Arr.toJS();
    const tab4Arr = this.props.tab4Arr.toJS();
    const bottomList = this.props.bottomList.toJS();
    return (
      <div className="lrlist">
        <Header />
        <div className="lrimg">
          <img src={imgListBanner1} alt="" />
        </div>
        <div className="lrselect mx1200 mauto">
          <div className="item clear">
            <span className="fl label">课程分类：</span>
            <div className="btng fr clear">
              {tab1Arr.map(function (item, index) {
                return (
                  <span
                    key={index}
                    className={item.id === curTab1Id ? "cur" : ""}
                    onClick={(ev) =>
                      handleTab1Click(item.id, curTab1Id, curTab4Id)
                    }
                  >
                    {item.name}
                  </span>
                );
              })}
            </div>
          </div>
          <div className="item clear">
            <span className="fl label">类型：</span>
            <div className="btng fr clear">
              {tab2Arr.map(function (item, index) {
                return (
                  <span
                    key={index}
                    className={item.id === curTab2Id ? "cur" : ""}
                    onClick={(ev) =>
                      handleTab2Click(item.id, curTab2Id, curTab1Id, curTab4Id)
                    }
                  >
                    {item.name}
                  </span>
                );
              })}
            </div>
          </div>

          {curTab1Id === 1 || !curTab2Id ? null : (
            <div className="item clear">
              <span className="fl label">科目：</span>
              <div className="btng fr clear">
                {tab3Arr.map(function (item, index) {
                  return (
                    <span
                      key={index}
                      className={item.id === curTab3Id ? "cur" : ""}
                      onClick={(ev) =>
                        handleTab3Click(
                          item.id,
                          curTab3Id,
                          curTab2Id,
                          curTab1Id,
                          curTab4Id
                        )
                      }
                    >
                      {item.name}
                    </span>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        <div className="lrselect mx1200 mauto">
          <div className="item clear">
            <span className="fl label">排序：</span>
            <div className="btng fr clear">
              {tab4Arr.map(function (item, index) {
                return (
                  <span
                    key={index}
                    className={item.id === curTab4Id ? "cur" : ""}
                    onClick={(ev) =>
                      handleTab4Click(item.id, curTab3Id, curTab2Id, curTab1Id)
                    }
                  >
                    {item.name}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
        {isLoader ? (
          <div className="loader">
            <ListLoader />
          </div>
        ) : bottomList.length !== 0 ? (
          <div>
            <div className="lritem mx1200 mauto clear">
              {bottomList.map(function (item, index) {
                return (
                  <div
                    className="item"
                    key={index}
                    onClick={(ev) => goVideo(history, item.classId, item.gradeId)}
                  >
                    <div className="imginfo">
                      {item.imgUrlAll ? (
                        <img src={item.imgUrlAll} alt="" />
                      ) : (
                        <img src={imgDefault} alt="" />
                      )}
                      {/* {item.imgUrl ? <img src={abbr.ip+item.imgUrl} alt=""/> : <img src={imgDefault} alt=""/>} */}
                    </div>
                    <div className="textinfo">
                      <div className="t">
                        <div className="title">{item.classTitle}</div>
                        {/* <div className="labelg">
													<span className="blue">名师分享</span>
													<span className="red">名师分享</span>
												</div> */}
                      </div>
                      <div className="b">
                        <span className="watch">
                          已有{item.listenNum}人观看
                        </span>
                        <span className="price">免费</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="lrpage">
              <Pagination
                showQuickJumper
                defaultCurrent={page}
                total={total}
                pageSize={16}
                onChange={(ev) =>
                  onPageSizeChange(ev, curTab1Id, curTab2Id, curTab3Id,curTab4Id)
                }
              />
            </div>
          </div>
        ) : (
          <NoList />
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tab1Arr: state.getIn(["list", "tab1Arr"]),
    tab2Arr: state.getIn(["list", "tab2Arr"]),
    tab3Arr: state.getIn(["list", "tab3Arr"]),
    tab4Arr: state.getIn(["list", "tab4Arr"]),
    curTab1Id: state.getIn(["list", "curTab1Id"]),
    curTab2Id: state.getIn(["list", "curTab2Id"]),
    curTab3Id: state.getIn(["list", "curTab3Id"]),
    curTab4Id: state.getIn(["list", "curTab4Id"]),
    isLoader: state.getIn(["list", "isLoader"]),
    bottomList: state.getIn(["list", "bottomList"]),
    page: state.getIn(["list", "page"]),
    total: state.getIn(["list", "total"]),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goVideo(history, id,gradeId) {
      //跳转视频页面
      const w = window.open("about:blank");
      w.location.href = abbr.twoLevel + "/video/" + id+ "_" +gradeId;
    },
    handleTab1Click(id, curId, curTab4Id) {
      //tab1一行点击
      if (id === curId) {
        return;
      }
      if (id === 1) {
        //口碑

        dispatch(actionCreators.changeTab2ArrTell());
        dispatch(actionCreators.changeTab2(1));
        dispatch(actionCreators.getListByTell(1, 16, 1, curTab4Id));
      } else {
        dispatch(actionCreators.changeTab2Arr());
        dispatch(actionCreators.changeTab2(null));
        dispatch(actionCreators.getListByTab1(1, 16, id, curTab4Id,curTab4Id));
      }
      dispatch(actionCreators.setLoader(true));
      dispatch(actionCreators.setPage(1));
      dispatch(actionCreators.changeTab1(id));
      dispatch(actionCreators.changeTab2(null));
      dispatch(actionCreators.changeTab3(null));
    },
    handleTab2Click(id, curId2, curId1, curId4) {
      //tab2一行点击
      if (id === curId2) {
        return;
      }
      if (curId1 === 1) {
        //口碑
        dispatch(actionCreators.getListByTell(1, 16, id, curId4));
      } else {
        if (id === 1) {
          //备考技巧
          dispatch(
            actionCreators.changeTab3Arr([
              { name: "全部课程", id: 1 },
              { name: "考试介绍", id: 2 },
              { name: "学习方法", id: 3 },
            ])
          );
          if (curId1 === 1011) {
            //一级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1098, 0, curId4,curId1));
          } else if (curId1 === 1012) {
            //二级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1097, 0, curId4,curId1));
          } else if (curId1 === 1060) {
            //消防工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1106, 0, curId4,curId1));
          } else if (curId1 === 1033) {
            //安全工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1157, 0, curId4,curId1));
          } else if (curId1 === 1013) {
            //监理工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1100, 0, curId4,curId1));
          } else if (curId1 === 1015) {
            //一级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1099, 0, curId4,curId1));
          } else if (curId1 === 1093) {
            //二级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1105, 0, curId4,curId1));
          } else if (curId1 === 1110) {
            //造价实操课
            dispatch(actionCreators.changeListSomeType(1, 16, 1159, 0, curId4,curId1));
          } else if (curId1 === 1061) {
            //中级职称（建筑）
            dispatch(actionCreators.changeListSomeType(1, 16, 1158, 0, curId4,curId1));
          } else if (curId1 === 1074) {
            //中级职称（市政）
            dispatch(actionCreators.changeListSomeType(1, 16, 1156, 0, curId4,curId1));
          } else if (curId1 === 1069) {
            //BIM工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1137, 0, curId4,curId1));
          } else if (curId1 === 1087) {
            //咨询工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1088, 0, curId4,curId1));
          } else if (curId1 === 1081) {
            //公路水运检测
            dispatch(actionCreators.changeListSomeType(1, 16, 1082, 0, curId4,curId1));
          }
        } else if (id === 2) {
          //热门知识
          if (curId1 === 1011) {
            //一级建造师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "工程经济", id: 1016 },
                { name: "法律法规", id: 1017 },
                { name: "项目管理", id: 1018 },
                { name: "建筑实务", id: 1019 },
                { name: "机电实务", id: 1020 },
                { name: "公路实务", id: 1022 },
                { name: "市政实务", id: 1034 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1012) {
            //二级建造师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "法律法规", id: 1023 },
                { name: "项目管理", id: 1024 },
                { name: "建筑实务", id: 1025 },
                { name: "机电实务", id: 1026 },
                { name: "公路实务", id: 1028 },
                { name: "市政实务", id: 1027 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1060) {
            //消防工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "案例分析", id: 1067 },
                { name: "技术实务", id: 1065 },
                { name: "综合能力", id: 1066 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1033) {
            //安全工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "安全生产法规", id: 1040 },
                { name: "安全生产技术", id: 1041 },
                { name: "安全生产管理", id: 1042 },
                { name: "安全生产实务（建筑）", id: 1125 },
                { name: "安全生产实务（化工）", id: 1160 },
                { name: "安全生产实务（其他）", id: 1043 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1013) {
            //监理工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "概论法规", id: 1029 },
                { name: "合同管理", id: 1030 },
                { name: "三大控制", id: 1031 },
                { name: "案例分析", id: 1032 },
                { name: "交通目标控制", id: 1194 },
                { name: "交通案例", id: 1193 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1015) {
            //一级造价师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "造价管理", id: 1035 },
                { name: "工程计价", id: 1036 },
                { name: "案例分析", id: 1037 },
                { name: "土建计量", id: 1038 },
                { name: "安装计量", id: 1039 },
                { name: "水利计量", id: 1118 },
                { name: "交通计量", id: 1117 },
                { name: "交通案例", id: 1136 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1093) {
            //二级造价师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "造价管理", id: 1094 },
                { name: "土建计量", id: 1095 },
                { name: "安装计量", id: 1096 },
                { name: "水利计量", id: 1102 },
                { name: "交通计量", id: 1101 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1110) {
            //造价实操课
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "土建工程", id: 1111 },
                { name: "电气安装", id: 1112 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1069) {
            //BIM工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "一级BIM", id: 1070 },
                { name: "二级BIM建筑", id: 1103 },
                { name: "二级BIM设备", id: 1076 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4)
            );
          } else if (curId1 === 1061) {
            //中级职称（建筑）
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "专业知识(建筑)", id: 1062 },
                { name: "法律法规(建筑)", id: 1063 },
                { name: "专业实务(建筑)", id: 1064 },
                { name: "专业知识(市政)", id: 1075 },
                { name: "法律法规(市政)", id: 1077 },
                { name: "专业实务(市政)", id: 1076 },
                { name: "专业知识（造价）", id: 1165 },
                { name: "法律法规（造价）", id: 1164 },
                { name: "专业实务（造价）", id: 1166 },
                { name: "专业知识（给排水）", id: 1169 },
                { name: "法律法规（给排水）", id: 1168 },
                { name: "专业实务（给排水）", id: 1170 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1087) {
            //咨询工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "宏观经济政策与发展规划", id: 1088 },
                { name: "工程项目组织与管理", id: 1089 },
                { name: "项目决策分析与评价", id: 1090 },
                { name: "现代咨询方法与实务", id: 1091 },
              ])
            );
          } else if (curId1 === 1081) {
            //公路水运检测
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "公共基础", id: 1082 },
                { name: "道路工程", id: 1083 },
                { name: "桥隧工程", id: 1084 },
                { name: "交通工程", id: 1092 },
                { name: "水运材料", id: 1204 },
                { name: "水运结构与地基", id: 1225 },
              ])
            );
          }
        } else if (id === 3) {
          //习题讲解
          if (curId1 === 1011) {
            //一级建造师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "经济习题", id: 1016 },
                { name: "法规习题", id: 1017 },
                { name: "管理习题", id: 1018 },
                { name: "建筑习题", id: 1019 },
                { name: "机电习题", id: 1020 },
                { name: "公路习题", id: 1022 },
                { name: "市政习题", id: 1034 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1012) {
            //二级建造师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "法规习题", id: 1023 },
                { name: "管理习题", id: 1024 },
                { name: "建筑习题", id: 1025 },
                { name: "机电习题", id: 1026 },
                { name: "公路习题", id: 1028 },
                { name: "市政习题", id: 1027 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1060) {
            //消防工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "案例习题", id: 1067 },
                { name: "技术习题", id: 1065 },
                { name: "综合习题", id: 1066 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1033) {
            //安全工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "安全生产法规", id: 1040 },
                { name: "安全生产技术", id: 1041 },
                { name: "安全生产管理", id: 1042 },
                { name: "安全生产实务（建筑）", id: 1125 },
                { name: "安全生产实务（化工）", id: 1160 },
                { name: "安全生产实务（其他）", id: 1043 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1013) {
            //监理工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "概论法规", id: 1029 },
                { name: "合同管理", id: 1030 },
                { name: "三大控制", id: 1031 },
                { name: "案例分析", id: 1032 },
                { name: "交通目标控制", id: 1194 },
                { name: "交通案例", id: 1193 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1015) {
            //一级造价师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "造价管理", id: 1035 },
                { name: "工程计价", id: 1036 },
                { name: "案例分析", id: 1037 },
                { name: "土建计量", id: 1038 },
                { name: "安装计量", id: 1039 },
                { name: "水利计量", id: 1118 },
                { name: "交通计量", id: 1117 },
                { name: "交通案例", id: 1136 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1093) {
            //二级造价师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "造价管理", id: 1094 },
                { name: "土建计量", id: 1095 },
                { name: "安装计量", id: 1096 },
                { name: "水利计量", id: 1102 },
                { name: "交通计量", id: 1101 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1110) {
            //造价实操课
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "土建工程", id: 1111 },
                { name: "电气安装", id: 1112 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1061) {
            //土建中级职称
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "专业知识(建筑)", id: 1062 },
                { name: "法律法规(建筑)", id: 1063 },
                { name: "专业实务(建筑)", id: 1064 },
                { name: "专业知识(市政)", id: 1075 },
                { name: "法律法规(市政)", id: 1077 },
                { name: "专业实务(市政)", id: 1076 },
                { name: "专业知识（造价）", id: 1165 },
                { name: "法律法规（造价）", id: 1164 },
                { name: "专业实务（造价）", id: 1166 },
                { name: "专业知识（给排水）", id: 1169 },
                { name: "法律法规（给排水）", id: 1168 },
                { name: "专业实务（给排水）", id: 1170 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1069) {
            //BIM工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "一级BIM", id: 1070 },
                { name: "二级BIM建筑", id: 1103 },
                { name: "二级BIM设备", id: 1076 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1074) {
            //土建中级职称（市政）
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "专业知识(建筑)", id: 1062 },
                { name: "法律法规(建筑)", id: 1063 },
                { name: "专业实务(建筑)", id: 1064 },
                { name: "专业知识(市政)", id: 1075 },
                { name: "法律法规(市政)", id: 1077 },
                { name: "专业实务(市政)", id: 1076 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1087) {
            //咨询工程师
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "宏观经济政策与发展规划", id: 1088 },
                { name: "工程项目组织与管理", id: 1089 },
                { name: "项目决策分析与评价", id: 1090 },
                { name: "现代咨询方法与实务", id: 1091 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          } else if (curId1 === 1081) {
            //公路水运检测
            dispatch(
              actionCreators.changeTab3Arr([
                { name: "全部课程", id: 1 },
                { name: "公共基础", id: 1082 },
                { name: "道路工程", id: 1083 },
                { name: "桥隧工程", id: 1084 },
                { name: "交通工程", id: 1092 },
                { name: "水运材料", id: 1204 },
                { name: "水运结构与地基", id: 1225 },
              ])
            );
            dispatch(
              actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4)
            );
          }
        }
      }
      dispatch(actionCreators.setLoader(true));
      dispatch(actionCreators.setPage(1));
      dispatch(actionCreators.changeTab2(id));
      dispatch(actionCreators.changeTab3(1));
    },
    handleTab3Click(id, curId3, curId2, curId1, curId4) {
      //tab2一行点击
      if (id === curId3) {
        return;
      }
      if (curId2 === 1) {
        //备考技巧
          console.log(id);console.log(123);
        if (id === 1) {
          //全部课程
          if (curId1 === 1011) {
            //一级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1098, 0, curId4,curId1));
          } else if (curId1 === 1012) {
            //二级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1097, 0, curId4,curId1));
          } else if (curId1 === 1060) {
            //消防工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1106, 0, curId4,curId1));
          } else if (curId1 === 1033) {
            //安全工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1157, 0, curId4,curId1));
          } else if (curId1 === 1013) {
            //监理工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1100, 0, curId4,curId1));
          } else if (curId1 === 1015) {
            //一级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1099, 0, curId4,curId1));
          } else if (curId1 === 1093) {
            //二级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1105, 0, curId4,curId1));
          } else if (curId1 === 1110) {
            //造价实操课
            dispatch(actionCreators.changeListSomeType(1, 16, 1159, 0, curId4,curId1));
          } else if (curId1 === 1061) {
            //中级职称（建筑）
            dispatch(actionCreators.changeListSomeType(1, 16, 1158, 0, curId4,curId1));
          } else if (curId1 === 1074) {
            //中级职称（市政）
            dispatch(actionCreators.changeListSomeType(1, 16, 1156, 0, curId4,curId1));
          } else if (curId1 === 1069) {
            //BIM工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1137, 0, curId4,curId1));
          } else if (curId1 === 1087) {
            //咨询工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1088, 0, curId4,curId1));
          } else if (curId1 === 1081) {
            //公路水运检测
            dispatch(actionCreators.changeListSomeType(1, 16, 1082, 0, curId4,curId1));
          }
        } else if (id === 2) {
          //考试介绍
          if (curId1 === 1011) {
            //一级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1098, 3, curId4,curId1));
          } else if (curId1 === 1012) {
            //二级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1097, 3, curId4,curId1));
          } else if (curId1 === 1060) {
            //消防工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1106, 3, curId4,curId1));
          } else if (curId1 === 1033) {
            //安全工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1157, 3, curId4,curId1));
          } else if (curId1 === 1013) {
            //监理工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1100, 3, curId4,curId1));
          } else if (curId1 === 1015) {
            //一级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1099, 3, curId4,curId1));
          } else if (curId1 === 1093) {
            //二级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1105, 3, curId4,curId1));
          } else if (curId1 === 1110) {
            //造价实操课
            dispatch(actionCreators.changeListSomeType(1, 16, 1159, 3, curId4,curId1));
          } else if (curId1 === 1061) {
            //中级职称（建筑）
            dispatch(actionCreators.changeListSomeType(1, 16, 1158, 3, curId4,curId1));
          } else if (curId1 === 1074) {
            //中级职称（市政）
            dispatch(actionCreators.changeListSomeType(1, 16, 1156, 3, curId4,curId1));
          } else if (curId1 === 1069) {
            //BIM工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1137, 3, curId4,curId1));
          } else if (curId1 === 1087) {
            //咨询工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1088, 3, curId4,curId1));
          } else if (curId1 === 1081) {
            //公路水运检测
            dispatch(actionCreators.changeListSomeType(1, 16, 1082, 3, curId4,curId1));
          }
        } else if (id === 3) {
          //学习方法
          if (curId1 === 1011) {
            //一级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1098, 4, curId4,curId1));
          } else if (curId1 === 1012) {
            //二级建造师
            dispatch(actionCreators.changeListSomeType(1, 16, 1097, 4, curId4,curId1));
          } else if (curId1 === 1060) {
            //消防工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1106, 4, curId4,curId1));
          } else if (curId1 === 1033) {
            //安全工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1157, 4, curId4,curId1));
          } else if (curId1 === 1013) {
            //监理工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1100, 4, curId4,curId1));
          } else if (curId1 === 1015) {
            //一级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1099, 4, curId4,curId1));
          } else if (curId1 === 1093) {
            //二级造价师
            dispatch(actionCreators.changeListSomeType(1, 16, 1105, 4, curId4,curId1));
          } else if (curId1 === 1110) {
            //造价实操课
            dispatch(actionCreators.changeListSomeType(1, 16, 1159, 4, curId4,curId1));
          } else if (curId1 === 1061) {
            //中级职称（建筑）
            dispatch(actionCreators.changeListSomeType(1, 16, 1158, 4, curId4,curId1));
          } else if (curId1 === 1074) {
            //中级职称（市政）
            dispatch(actionCreators.changeListSomeType(1, 16, 1156, 4, curId4,curId1));
          } else if (curId1 === 1069) {
            //BIM工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1137, 4, curId4,curId1));
          } else if (curId1 === 1087) {
            //咨询工程师
            dispatch(actionCreators.changeListSomeType(1, 16, 1088, 4, curId4,curId1));
          } else if (curId1 === 1081) {
            //公路水运检测
            dispatch(actionCreators.changeListSomeType(1, 16, 1082, 4, curId4,curId1));
          }
        }
      } else if (curId2 === 2) {
        //热门知识
        if (id === 1) {
          //全部课程
          dispatch(actionCreators.changeListOtherAll(1, 16, curId1, 1, curId4));
        } else {
          dispatch(actionCreators.changeListSomeType(1, 16, id, 1, curId4,curId1));
        }
      } else if (curId2 === 3) {
        //习题讲解
        if (id === 1) {
          //全部课程
          dispatch(actionCreators.changeListOtherAll(1, 16, curId1, 2, curId4));
        } else {
          dispatch(actionCreators.changeListSomeType(1, 16, id, 2, curId4,curId1));
        }
      }
      dispatch(actionCreators.changeTab3(id));
    },
    // 按更新时间的点击事件
    handleTab4Click(id, curTab3Id, curTab2Id, curTab1Id) {
      let arr = 1;
      arr = id;
      dispatch(actionCreators.changeTab4(id));
      if (curTab1Id && curTab2Id && curTab3Id) {
        //  如果第一行是口碑，执行该语句
        if (curTab1Id === 1)
          return dispatch(actionCreators.getListByTell(1, 16, curTab2Id, id));
        // -------------------------------
        // 根据上方选择的不同，在下方传递不同的数据
        dispatch(
          actionCreators.changeListSomeType(
            1,
            16,
            curTab2Id === 1 ? "" : null ||
            curTab3Id === 1 ? "" : curTab3Id,
            curTab2Id === 3? 2: 0 || 
            curTab2Id === 2? 1: 0 || 
            curTab2Id === 1? 0: 0,
            arr,curTab1Id
          )
        );
      } else if (curTab1Id && curTab2Id) {
        actionCreators.changeListOtherAll(1, 16, curTab1Id, curTab2Id, arr);
      } else if (curTab1Id) {
        //  如果第一行是口碑，执行该语句
        if (curTab1Id === 1)
          return dispatch(actionCreators.getListByTell(1, 16, curTab2Id, id));
        // -------------------------------
        dispatch(actionCreators.setPage(1));
        dispatch(actionCreators.setLoader(true));
        dispatch(actionCreators.getListByTab1(1, 16, curTab1Id, arr));
      }
    },
    onPageSizeChange(page, curId1, curId2, curId3,curTab4Id) {
        console.log(curTab4Id)
      if (curId1 === 1) {
        //口碑
        dispatch(actionCreators.getListByTell(page, 16, curId2));
      } else if (curId1 === 1011) {
        //一级建造师
        if (!curId2) {
          //全部一建
          dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
        } else if (curId3 === 1) {
          //全部方面
          if (curId2 === 1) {
            //备考技巧
            dispatch(actionCreators.changeListSomeType(page, 16, 1098, 0,curTab4Id));
          } else if (curId2 === 2) {
            //热门知识
            dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
          }
          if (curId2 === 3) {
            //习题讲解
            dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
          }
        } else {
          //非全部
          if (curId2 === 1) {
            //备考技巧
            if (curId3 === 1) {
              //考试介绍
              dispatch(actionCreators.changeListSomeType(page, 16, 1098, 3,curTab4Id));
            } else {
              //学习方法
              dispatch(actionCreators.changeListSomeType(page, 16, 1098, 4,curTab4Id));
            }
          } else {
            dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
          }
        }
      } else if (curId1 === 1012) {
        //二级建造师
        if (!curId2) {
          //全部一建
          dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
        } else if (curId3 === 1) {
          //全部方面
          if (curId2 === 1) {
            //备考技巧
            dispatch(actionCreators.changeListSomeType(page, 16, 1097, 0,curTab4Id));
          } else if (curId2 === 2) {
            //热门知识
            dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
          }
          if (curId2 === 3) {
            //习题讲解
            dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2));
          }
        } else {
          //非全部
          if (curId2 === 1) {
            //备考技巧
            if (curId3 === 1) {
              //考试介绍
              dispatch(actionCreators.changeListSomeType(page, 16, 1097, 3));
            } else {
              //学习方法
              dispatch(actionCreators.changeListSomeType(page, 16, 1097, 4));
            }
          } else {
            dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1));
          }
        }
      }else if (curId1 === 1013) {
          //监理工程师
          if (!curId2) {
              //全部一建
              dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
          } else if (curId3 === 1) {
              //全部方面
              if (curId2 === 1) {
                  //备考技巧
                  dispatch(actionCreators.changeListSomeType(page, 16, 1100, 0,curTab4Id));
              } else if (curId2 === 2) {
                  //热门知识
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
              }
              if (curId2 === 3) {
                  //习题讲解
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
              }
          } else {
              //非全部
              if (curId2 === 1) {
                  //备考技巧
                  if (curId3 === 1) {
                      //考试介绍
                      dispatch(actionCreators.changeListSomeType(page, 16, 1100, 3,curTab4Id));
                  } else {
                      //学习方法
                      dispatch(actionCreators.changeListSomeType(page, 16, 1100, 4,curTab4Id));
                  }
              } else {
                  dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
              }
          }
      }else if (curId1 === 1015) {
          //一造
          if (!curId2) {
              //全部一建
              dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
          } else if (curId3 === 1) {
              //全部方面
              if (curId2 === 1) {
                  //备考技巧
                  dispatch(actionCreators.changeListSomeType(page, 16, 1099, 0,curTab4Id));
              } else if (curId2 === 2) {
                  //热门知识
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
              }
              if (curId2 === 3) {
                  //习题讲解
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
              }
          } else {
              //非全部
              if (curId2 === 1) {
                  //备考技巧
                  if (curId3 === 1) {
                      //考试介绍
                      dispatch(actionCreators.changeListSomeType(page, 16, 1099, 3,curTab4Id));
                  } else {
                      //学习方法
                      dispatch(actionCreators.changeListSomeType(page, 16, 1099, 4,curTab4Id));
                  }
              } else {
                  dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
              }
          }
      }else if (curId1 === 1060) {
        //消防工程师
        if (!curId2) {
          //全部一建
          dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
        } else if (curId3 === 1) {
          //全部方面
          if (curId2 === 1) {
            //备考技巧
            dispatch(actionCreators.changeListSomeType(page, 16, 1106, 0,curTab4Id));
          } else if (curId2 === 2) {
            //热门知识
            dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
          }
          if (curId2 === 3) {
            //习题讲解
            dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
          }
        } else {
          //非全部
          if (curId2 === 1) {
            //备考技巧
            if (curId3 === 1) {
              //考试介绍
              dispatch(actionCreators.changeListSomeType(page, 16, 1106, 3,curTab4Id));
            } else {
              //学习方法
              dispatch(actionCreators.changeListSomeType(page, 16, 1106, 4,curTab4Id));
            }
          } else {
            dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
          }
        }
      }else if (curId1 === 1033) {
          //安全工程师
          if (!curId2) {
              //全部安全
              dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
          } else if (curId3 === 1) {
              //全部方面
              if (curId2 === 1) {
                  //备考技巧
                  dispatch(actionCreators.changeListSomeType(page, 16, 1157, 0,curTab4Id));
              } else if (curId2 === 2) {
                  //热门知识
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
              }
              if (curId2 === 3) {
                  //习题讲解
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
              }
          } else {
              //非全部
              if (curId2 === 1) {
                  //备考技巧
                  if (curId3 === 1) {
                      //考试介绍
                      dispatch(actionCreators.changeListSomeType(page, 16, 1157, 3,curTab4Id));
                  } else {
                      //学习方法
                      dispatch(actionCreators.changeListSomeType(page, 16, 1157, 4,curTab4Id));
                  }
              } else {
                  dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
              }
          }
      }else if (curId1 === 1061) {
          //土建中级职称
          if (!curId2) {
              //全部安全
              dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
          } else if (curId3 === 1) {
              //全部方面
              if (curId2 === 1) {
                  //备考技巧
                  dispatch(actionCreators.changeListSomeType(page, 16, 1158, 0,curTab4Id));
              } else if (curId2 === 2) {
                  //热门知识
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
              }
              if (curId2 === 3) {
                  //习题讲解
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
              }
          } else {
              //非全部
              if (curId2 === 1) {
                  //备考技巧
                  if (curId3 === 1) {
                      //考试介绍
                      dispatch(actionCreators.changeListSomeType(page, 16, 1158, 3,curTab4Id));
                  } else {
                      //学习方法
                      dispatch(actionCreators.changeListSomeType(page, 16, 1158, 4,curTab4Id));
                  }
              } else {
                  dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
              }
          }
      }else if (curId1 === 1093) {
          //二造
          if (!curId2) {
              //全部安全
              dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
          } else if (curId3 === 1) {
              //全部方面
              if (curId2 === 1) {
                  //备考技巧
                  dispatch(actionCreators.changeListSomeType(page, 16, 1105, 0,curTab4Id));
              } else if (curId2 === 2) {
                  //热门知识
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
              }
              if (curId2 === 3) {
                  //习题讲解
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
              }
          } else {
              //非全部
              if (curId2 === 1) {
                  //备考技巧
                  if (curId3 === 1) {
                      //考试介绍
                      dispatch(actionCreators.changeListSomeType(page, 16, 1105, 3,curTab4Id));
                  } else {
                      //学习方法
                      dispatch(actionCreators.changeListSomeType(page, 16, 1105, 4,curTab4Id));
                  }
              } else {
                  dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
              }
          }
      }else if (curId1 === 1110) {
            //造价实操课
          if (!curId2) {
              //全部安全
              dispatch(actionCreators.getListByTab1(page, 16, curId1,curTab4Id));
          } else if (curId3 === 1) {
              //全部方面
              if (curId2 === 1) {
                  //备考技巧
                  dispatch(actionCreators.changeListSomeType(page, 16, 1159, 0,curTab4Id));
              } else if (curId2 === 2) {
                  //热门知识
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 1,curTab4Id));
              }
              if (curId2 === 3) {
                  //习题讲解
                  dispatch(actionCreators.changeListOtherAll(page, 16, curId1, 2,curTab4Id));
              }
          } else {
              //非全部
              if (curId2 === 1) {
                  //备考技巧
                  if (curId3 === 1) {
                      //考试介绍
                      dispatch(actionCreators.changeListSomeType(page, 16, 1159, 3,curTab4Id));
                  } else {
                      //学习方法
                      dispatch(actionCreators.changeListSomeType(page, 16, 1159, 4,curTab4Id));
                  }
              } else {
                  dispatch(actionCreators.changeListSomeType(page, 16, curId3, 1,curTab4Id));
              }
          }
      }
      dispatch(actionCreators.setPage(page));
      dispatch(actionCreators.setLoader(true));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
